import {
  isoDateSchema,
  numberStringSchema,
  optionalNumberStringSchema,
  refineDateRange,
  standardStringSchema,
  trimmedStringSchema,
} from "@/schemas"
import { z } from "zod"

const changeReasonMaxLength = 255

export const editBillSchema = z
  .object({
    startDate: isoDateSchema,
    endDate: isoDateSchema,
    usage: numberStringSchema,
    usageUnit: standardStringSchema.min(1),
    cost: optionalNumberStringSchema,
    currency: standardStringSchema.default(""),
    changeReason: trimmedStringSchema.max(changeReasonMaxLength).default(""),
  })
  .superRefine(refineDateRange)

export type EditBillSchema = z.infer<typeof editBillSchema>
